import '../doppe-public-path'

import {doppeUserAppClientBootstrap} from "./doppe-user-app-client-bootstrap";

doppeUserAppClientBootstrap();
